var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { AuthProjectUser } from "./ProjectUser.js";
import { UserLite } from "./User.js";
export class AuthToken {
}
export class LoginResponse {
    constructor() {
        this.auth_token = new AuthToken();
    }
}
__decorate([
    Type(() => AuthToken)
], LoginResponse.prototype, "auth_token", void 0);
__decorate([
    Type(() => UserLite)
], LoginResponse.prototype, "user", void 0);
__decorate([
    Type(() => AuthProjectUser)
], LoginResponse.prototype, "auth_project_user", void 0);
